<script>
	import ImageOptimiser from '$lib/components/common/ImageOptimiser.svelte';
	import doubleQuotes from '$ravioli/lib/assets/icons/double-quotes.svg';
	import rightArrow from '$ravioli/lib/assets/icons/right-arrow.svg';
	import header from '$ravioli/lib/assets/images/header.png';
</script>

<div
	class="mx-auto flex max-w-screen-2xl flex-col justify-between gap-16 pb-20 pt-32 md:flex-row md:items-center md:px-12 md:py-32  md:gap-5"
>
	<div class="flex max-w-md flex-col gap-3 px-4 md:px-0 md:max-w-[510px]">
		<img src={doubleQuotes} alt="double quotes" class="w-8 md:w-12" />
		<p class="font-lora text-2xl/9 font-medium md:text-[40px]/[56px]">
			Healthy and delicious meals delivered fresh daily at your doorstep!
		</p>
		<p class="text-base md:text-xl/8">
			Created by certified nutritionists and award winning chefs.
		</p>
		<a
			href="#our-meal-plans"
			class="flex  items-center gap-3 rounded-lg bg-[#ED292D] md:bind:clientHeight px-3 py-2 font-medium w-[180px] md:w-[220px] text-center justify-center mt-4"
		>
			<p class="text-base/5 text-white md:leading-6">Explore plans</p>
			<img src={rightArrow} alt="right arrow" />
		</a>
	</div>
	<div class="flex-none md:min-w-[250px] md:max-w-[480px] lg:w-[643px] lg:max-w-[643px]">
		<ImageOptimiser
			src={header}
			alt="Header image"
			imageSourceType="internal"
			classes={{ container: 'w-full h-auto object-cover', image: 'w-full h-full object-cover max-w-screen-sm' }}
		/>
	</div>
</div>
